import { useDispatch, useSelector } from "react-redux";
import { setMessage } from "../redux/actions/auth";

export const useCheckSystemStatus = () => {
  const dispatch = useDispatch();
  const system = useSelector(state => state.system);

  const checkSystemStatus = () => {
    const isSystemActive = !(
      system?.SettingsPromo?.isPromo && 
      new Date() <= new Date(system?.SettingsPromo?.startActive)
    );
    if (!isSystemActive) {
      const startDate = new Date(system?.SettingsPromo?.startActive).toLocaleDateString();
      dispatch(setMessage({
        type: 'error',
        message: `Будь ласка, дочекайтесь активації сервісу ${startDate}`
      }));
    }
    return isSystemActive;
  };
  return checkSystemStatus; 
};